module.exports = __webpack_public_path__ + "img/174-ae3775.png";